"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locales = void 0;
var locales = {
  de: {
    headline: "3 einfache Schritte zur App",
    step1: 'Tippen Sie auf das "Aktions-Symbol" in Ihrer Toolbar',
    step2: "Zum Home-Bildschirm",
    step3: "Die App wurde jetzt zu Ihrem Homescreen hinzugefügt"
  }
};
exports.locales = locales;